import { IRegistry } from '../../models/registry.interface';
import { IEntry, IEntryJob, EntryJobTotals } from '../../models/entry.interface';
import { Loadable, ILoadableArray, createDefaultLoadable, createDefaultILoadableArray } from '../../models/loadable';

export interface RegistryState extends Loadable {
    registries: IRegistry[];
    saving: Loadable;
    deleting: Loadable;

    selectedRegistry: IRegistry | null;
    selectedRegistryLoading: Loadable;

    entries: ILoadableArray<IEntry>;
    entriesRegistryId: string | null;
    entryJobs: ILoadableArray<IEntryJob>;
    entryJobsRegistryId: string | null;
    entryJobTotals: EntryJobTotals;
    currentJobFilter: string | null;

    creatingEntry: Loadable;
    updatingEntry: Loadable;
    deletingEntries: Loadable;
    bulkCreatingEntries: Loadable;
}

export const initialRegistryState: RegistryState = {
    ...createDefaultLoadable(),
    registries: [],
    saving: createDefaultLoadable(),
    deleting: createDefaultLoadable(),

    selectedRegistry: null,
    selectedRegistryLoading: createDefaultLoadable(),

    entries: createDefaultILoadableArray<IEntry>(),
    entriesRegistryId: null,
    entryJobs: createDefaultILoadableArray<IEntryJob>(),
    entryJobsRegistryId: null,
    entryJobTotals: { pending: 0, failed: 0 },
    currentJobFilter: null,

    creatingEntry: createDefaultLoadable(),
    updatingEntry: createDefaultLoadable(),
    deletingEntries: createDefaultLoadable(),
    bulkCreatingEntries: createDefaultLoadable(),
};
